const ITEMS = [
  "Office & Facility Relocation",
  "Decommissioning",
  "Biotech & Lab Services",
  "Healthcare Relocation",
  "Commercial Flooring",
  "Space Planning",
  "Corporate Cleaning",
  "Short-Term Storage",
  "Employee Mobility",
  "Local & Long Distance",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-ribbon" className="bg-navy py-4 overflow-hidden border-y border-white/10">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-6 px-6 font-display text-sm uppercase tracking-[0.25em] text-white/50">
            {item}
            <span className="w-1.5 h-1.5 bg-brand rotate-45 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
